/* eslint-disable  @typescript-eslint/no-explicit-any */
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

import { ALL_PROFILES } from 'graphql/profiles/profiles.query';
import { getUser } from 'utils/user';
import { ProfileData } from 'views/profiles/types/profile.types';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }: any) => {
  const user = getUser();

  const theme: any = useTheme();

  const [load, { loading, data }] = useLazyQuery(ALL_PROFILES);

  const [profiles, setProfiles] = useState<ProfileData[]>([]);

  const rolePermissions = profiles.find((profile) => profile.name === user.role);
  const permissions: Record<string, string[] | undefined> = rolePermissions?.permissions || ({} as Record<string, string[]>);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      load();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return () => (mounted = false as any);
  }, [load]);

  useEffect(() => {
    if (data) {
      setProfiles(data.allProfiles.result);
    }
  }, [data]);

  // menu list collapse & items
  const items = item.children
    .filter((menu: any) => {
      const [page, action] = menu.id.split('-');

      return permissions[page] && permissions[page]?.includes(action);
    })
    ?.map((menu: any) => {
      if (menu.type === 'collapse') {
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      }

      if (menu.type === 'item') {
        return <NavItem key={menu.id} item={menu} level={1} />;
      }

      return <></>;
    });

  if (loading || !items.length) return <></>;

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>
      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
